import Link from '@src/basic-components/Link/Link';
import TopicGhostChip from '@src/basic-components/TopicChip/TopicGhostChip';
import { ensureTokenUrl } from '@src/model/config/helpers';
import { memo, useCallback, useMemo } from 'react';
import type { FC } from 'react';
import { useNavigate } from 'react-router';

interface TopicsBarItemProps {
    className?: string;
    tokenName: string;
    isActive?: boolean;
    name: string;
    id: string;
    preventScrollToTop?: boolean;
}

const TopicsBarItem: FC<TopicsBarItemProps> = props => {
    const { id, tokenName, name, isActive, preventScrollToTop } = props;

    const url = useMemo(() => (isActive ? `/${ensureTokenUrl(tokenName)}` : `/${ensureTokenUrl(tokenName)}/${id}`), [isActive, id, tokenName]);
    const toLocationDescriptor = useMemo(() => ({ pathname: url, state: { preventScrollToTop } }), [url, preventScrollToTop]);
    return (
        <Link toLocationDescriptor={toLocationDescriptor} className="topics-bar-item">
            <TopicGhostChip isActive={isActive} id={id} name={name} />
        </Link>
    );
};

export default memo(TopicsBarItem);
